import { CardPocketSkeleton } from '@/common/components/CardPocket/CardPocket';
import { ROUTES } from '@/common/constants/routes';
import { HomeInsuranceCard } from '@/common/containers/Dashboard/Home/HomeInsuranceCard/HomeInsuranceCard';
import { HomeLayout } from '@/common/containers/Dashboard/Home/HomeLayout/HomeLayout';
import { PTBenefitsCardPocket } from '@/common/containers/Dashboard/Home/PTHomePage/PTBenefitsCardPocket/PTBenefitsCardPocket';
import { PTBudgetsCardPocket } from '@/common/containers/Dashboard/Home/PTHomePage/PTBudgetsCardPocket/PTBudgetsCardPocket';
import { PTEWACardPocket } from '@/common/containers/Dashboard/Home/PTHomePage/PTEWACardPocket/PTEWACardPocket';
import {
  useGetPTHomeAlerts,
  useGetPTHomeSecondaryActions,
} from '@/common/containers/Dashboard/Home/PTHomePage/PTHomePage.utils';
import { PTMealCardPocket } from '@/common/containers/Dashboard/Home/PTHomePage/PTMealCardPocket/PTMealCardPocket';
import { PTOptInCard } from '@/common/containers/Dashboard/Home/PTHomePage/PTOptInCard/PTOptInCard';
import { PocketCardsGrid } from '@/common/containers/Dashboard/Home/PocketCardsGrid/PocketCardsGrid';
import { InsuranceUpgradePlanBanner } from '@/common/containers/Dashboard/Insurance/components/InsuranceUpdgradePlanBanner/InsuranceUpgradePlanBanner';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useGetBenefitOptin } from '@/common/integrations/menhir/employee/benefits/benefits.hooks';
import { useBudgetsSummary } from '@/common/integrations/menhir/employee/budgets/budgets.hooks';
import { useGetInsurancePolicies } from '@/common/integrations/menhir/employee/insurance/insurance.hooks';
import { useGetPockets } from '@/common/integrations/menhir/employee/pockets/pockets.hooks';
import { useGetEWADetails } from '@/common/integrations/menhir/employee/salary/salary.hooks';
import { useBenefits } from '@/web/hooks/useBenefits';

export function PTWalletHomePage() {
  const alerts = useGetPTHomeAlerts();
  const secondaryActions = useGetPTHomeSecondaryActions();
  const {
    features: { ff_sea_activity },
  } = useFeatures();

  const { optIn } = useGetBenefitOptin();

  const { policies } = useGetInsurancePolicies();
  const healthPolicy = policies?.find(
    (policy) => policy.product.plan.type === 'health'
  );

  return (
    <HomeLayout
      alertsSlot={alerts}
      primaryActionsSlot={
        <>
          {optIn && <PTOptInCard optIn={optIn} />}
          <InsuranceUpgradePlanBanner />
        </>
      }
      pocketCardsSlot={<PTWalletPocketCards />}
      secondaryActionsSlot={secondaryActions}
      bottomSlot={healthPolicy && <HomeInsuranceCard policy={healthPolicy} />}
      activityRoute={ff_sea_activity ? ROUTES.HOME_ACTIVITY : ROUTES.ACTIVITY}
    />
  );
}

function PTWalletPocketCards() {
  const {
    benefitProducts,
    mealProducts,
    loading: loadingBenefits,
  } = useBenefits();
  const {
    mealPocket,
    benefitsPocket,
    loading: loadingPockets,
  } = useGetPockets();
  const { budgetsAvailable, loading: loadingBudgets } = useBudgetsSummary();
  const getEWADetails = useGetEWADetails();

  const hasBenefits = Boolean(benefitsPocket && benefitProducts?.length);
  const hasMeal = Boolean(mealPocket && mealProducts?.length);
  const hasEWA = Boolean(getEWADetails.details);

  if (loadingBenefits || loadingPockets || loadingBudgets) {
    return (
      <PocketCardsGrid>
        <CardPocketSkeleton />
        <CardPocketSkeleton />
      </PocketCardsGrid>
    );
  }

  return (
    <PocketCardsGrid>
      {hasMeal && <PTMealCardPocket route={ROUTES.MEAL} />}
      {hasBenefits && <PTBenefitsCardPocket />}
      {budgetsAvailable && <PTBudgetsCardPocket />}
      {hasEWA && <PTEWACardPocket />}
    </PocketCardsGrid>
  );
}
